import { PayloadAction, createReducer } from '@reduxjs/toolkit'

import { arrayToObject } from 'helpers/Functions'
import { EconomySet } from 'types/GlobalEconomySets'

import * as economyAccountActions from '../../actions/EconomyAccounts/actions'
import * as economySetActions from '../../actions/EconomySets/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type EconomySetBody = {
  [key: string]: EconomySet
}
export interface EconomySetReducerType {
  data: EconomySetBody
  fetched: boolean
  fetching: boolean
}

// Initial state
const INITIAL_STATE: EconomySetReducerType = {
  data: {},
  fetched: false,
  fetching: false
}

const setEconomySet = (
  state: EconomySetReducerType,
  action: PayloadAction<EconomySet>
) => {
  state.data[action.payload.id] = action.payload
}

// Reducer
export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(economySetActions.getAll, (state) => {
      state.fetching = true
    })
    .addCase(economySetActions.getAllSuccess, (state, action) => {
      state.data = arrayToObject(action.payload) as EconomySetBody
      state.fetched = true
      state.fetching = false
    })
    .addCase(economySetActions.getAllFailed, (state) => {
      state.fetching = false
    })
    .addCase(economySetActions.createSuccess, setEconomySet)
    .addCase(economySetActions.duplicateSuccess, setEconomySet)
    .addCase(economySetActions.updateSuccess, setEconomySet)
    .addCase(economySetActions.updateCompaniesSuccess, setEconomySet)
    .addCase(economySetActions.uploadSuccess, setEconomySet)
    .addCase(economySetActions.destroySuccess, (state, action) => {
      delete state.data[action.payload.id]
    })
    .addCase(economyAccountActions.createSuccess, (state, action) => {
      const { data, economySetId } = action.payload

      state.data[economySetId].accounts.push(data)
    })
    .addCase(economyAccountActions.updateSuccess, (state, action) => {
      const { data, economySetId } = action.payload
      const set = state.data[economySetId]

      set.accounts = set.accounts.map((acc) =>
        acc.id === data.id ? data : acc
      )
    })
    .addCase(economyAccountActions.destroySuccess, (state, action) => {
      const { id, economySetId } = action.payload
      const set = state.data[economySetId]

      set.accounts = set.accounts.filter((acc) => acc.id !== id)
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})
